import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// component
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SpinnerComponent } from './spinner/spinner.component';
// import { SpinnerComponent } from './spinner/spinner.component';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    SpinnerComponent
  ],
  imports: [
    CommonModule,

  ],
  exports: [BreadcrumbsComponent,SpinnerComponent]
})
export class SharedModule { }
